import { useEffect, useMemo, useContext } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { fetchTrendingDestinations } from 'actions/DestinationAlertsActions'
import GeoContext from 'contexts/geoContext'
import { trendingHotelDestinations } from 'home/components/TrendingDestinations/constants'
import { getPopularFlightImages } from './popularFlightImages'

function useDestinationImages(
  destinations: Array<App.AirportLocation>,
): Record<string, string | undefined> {
  const dispatch = useAppDispatch()
  const { currentRegionCode } = useContext(GeoContext)

  useEffect(() => {
    dispatch(fetchTrendingDestinations())
  }, [dispatch])

  const apiTrending = useAppSelector(state => state.destination?.trendingDestinations)

  return useMemo(() => getPopularFlightImages(
    destinations,
    (apiTrending ?? []).map(destination => ({ name: destination.primaryText, imageId: destination.imageId })),
    trendingHotelDestinations[currentRegionCode] ?? trendingHotelDestinations.AU ?? [],
  ), [destinations, apiTrending, currentRegionCode])
}

export default useDestinationImages
